import { Modal } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { Divider } from 'antd'
import { NAMESPACE } from 'locale'
import { carePlansConstants } from 'locale/carePlans'
import type React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

interface RemoveNeedModalProps {
  isModalVisible: boolean
  setIsModalVisible: (visible: boolean) => void
  onConfirm: () => void
  onCancel: () => void
}

const RemoveNeedModal: React.FC<RemoveNeedModalProps> = ({
  isModalVisible,
  setIsModalVisible,
  onConfirm,
  onCancel
}) => {
  const { t } = useTranslation(NAMESPACE.CARE_PLANS)

  return (
    <StyledModal
      localisation={{
        title: t(carePlansConstants.REMOVE_NEED_MODAL_TITLE),
        confirmText: t(carePlansConstants.REMOVE_NEED_MODAL_CONFIRM),
        cancelText: t(carePlansConstants.REMOVE_NEED_MODAL_CANCEL)
      }}
      onConfirm={onConfirm}
      onCancel={onCancel}
      isModalVisible={isModalVisible}
      setIsModalVisible={setIsModalVisible}
      closeButton
      closeOnConfirm={false}
      noPadding
      confirmButtonProps={{ variant: 'danger' }}
    >
      <Divider style={{ margin: '0' }} />
      <StyledContent>
        <Text level={1} weight="medium">
          {t(carePlansConstants.REMOVE_NEED_MODAL_BODY)}
        </Text>
      </StyledContent>
    </StyledModal>
  )
}

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid ${({ theme }) => theme.color.neutral.color8};
`

const StyledModal = styled(Modal)`
  min-width: 600px;

  .ant-modal-content {
    padding-top: 20px !important;
    padding-left: 24px !important;
    padding-right: 24px !important;
  }

  .ant-modal-header {
    padding-bottom: 4px !important;
  }

  .ant-modal-title {
    font-size: 22px !important;
    font-weight: 500 !important;
    text-transform: none !important;
    color: ${({ theme }) => theme.color.neutral.color3} !important;
  }

  .ant-modal-footer {
    margin-top: 0 !important;
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
`

export default RemoveNeedModal
